import React, { useRef, useState } from "react";
import { Button, Modal, Toast, Alert } from '@themesberg/react-bootstrap';
import { AddBannerForm } from "./partials/AddBannerForm";
import { useCookies } from "react-cookie";
import { add } from "../../../../../controller/api/banner";

export default (props) => {

  const [cookies] = useCookies(['lottmekong'])

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [success, setSuccess] = useState(false)

  const imageRef = useRef(null)

  const onImageChange = (image) => {
    imageRef.current = image
  }

  const validate = async () => {
    if (!imageRef.current) {
      setErrorMessage('Vui lòng chọn hình ảnh')
      setError(true)
      return
    }

    setLoading(true)
    setError(false)
    setSuccess(false)

    try {
      const resp = await add(cookies.lottmekong, imageRef.current, 1)
      if (resp && resp.status === 'success') {
        setSuccess(true)
        setTimeout(() => {
          window.location.reload()
        }, 1500)
      } else {
        setErrorMessage(resp?.message || 'Có lỗi xảy ra khi thêm banner')
        setError(true)
      }
    } catch (e) {
      console.error('Add banner error:', e)
      setErrorMessage('Có lỗi xảy ra khi thêm banner')
      setError(true)
    } finally {
      setLoading(false)
    }
  }

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Thêm quảng cáo
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && (
          <Alert variant="danger" onClose={() => setError(false)} dismissible>
            <Alert.Heading>Lỗi!</Alert.Heading>
            <p>{errorMessage}</p>
          </Alert>
        )}
        
        {success && (
          <Alert variant="success">
            <Alert.Heading>Thành công!</Alert.Heading>
            <p>Banner đã được thêm thành công. Đang tải lại trang...</p>
          </Alert>
        )}
        
        <AddBannerForm
          setImage={onImageChange}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={props.onHide} disabled={loading}>
          Đóng
        </Button>
        <Button 
          variant="primary" 
          onClick={validate} 
          disabled={loading}
        >
          {loading ? 'Đang xử lý...' : 'Thêm banner'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
